export default __webpack_public_path__ + "img/sustainable-activewear.b9c7c279.png";